import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LinkBox from "./LinkBox";

type AppLinkData = {
    title: string
    link: string;
    img?: string;
    filename: string;
}
export const AppLinks: React.FC = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const data: AppLinkData[] = [
        {
            title: "Android app 2",
            link: "https://play.google.com/store/apps/details?id=com.nutilogi.nutilogi",
            filename: "nutilogi_android_app_qr",
            img: "https://play-lh.googleusercontent.com/aGQVQ5zxDQG8WXFoHKIcCxWTNL0MzCB4AzKKn-F0e3k-fCVP4GtRr_DoKgDmRVRtITY=w480-h960-rw"
        },
        {
            title: "iOS app 2",
            link: "https://apps.apple.com/us/app/nutilogi-2/id1572706845",
            filename: "nutilogi_ios_app_qr",
            img: "https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/4d/3c/db/4d3cdb3a-2577-11ee-6c98-917442d0e519/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/460x0w.webp"
        },
        {
            title: "Android app 1",
            link: "https://play.google.com/store/apps/details?id=com.argo.nutilogi",
            filename: "nutilogi_android_app_qr",
            img: "https://play-lh.googleusercontent.com/IMxVuyIjLFUvIjt_0OIDKxJQRHynzaA9v0BatzCXFaVFFrHTW6zWJPY-rlC5Lrwv8w=w480-h960-rw"
        },
        {
            title: "iOS app 1",
            link: "https://apps.apple.com/us/app/nutilogi/id1498594669",
            filename: "nutilogi_ios_app_qr",
            img: "https://is1-ssl.mzstatic.com/image/thumb/Purple125/v4/bf/a2/7c/bfa27c5e-c47c-7d36-0c7c-7c669042c056/AppIcon-1x_U007emarketing-0-7-0-85-220.png/460x0w.webp"
        },
        {
            title: "Android organizer",
            link: "https://play.google.com/store/apps/details?id=com.nutilogi.organizer",
            filename: "nutilogi_android_organizer_qr",
            img: "https://play-lh.googleusercontent.com/MXdNVyXwPebLVsdG08ABAsiW-kpio2yY9If9bbbeKMWzSa_04AyHqVhbqQpVtjzt-GoP=w480-h960-rw"
        },
        {
            title: "iOS organizer",
            link: "https://apps.apple.com/us/app/nutilogi-organizer/id6448961564",
            filename: "nutilogi_iosorganizer_qr"
        }

    ]
    return <>
        <Button variant="contained" onClick={() => setOpen(true)}>

            {t("button.applinks")}
        </Button>
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth={false}
        >
            <DialogTitle>{t("title.linkstoapps")}</DialogTitle>
            <DialogContent>
                <Table>
                    <TableBody>
                        {data.map((e) => <TableRow>
                            <TableCell>
                                {e.img && <img src={e.img} width={64} height={64} alt="logo" />}
                            </TableCell>
                            <TableCell>{e.title}</TableCell>
                            <TableCell>
                                <LinkBox
                                    title={e.title}
                                    downloadfilename={e.filename}
                                    link={e.link} />
                            </TableCell>
                        </TableRow>)
                        }
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={() => setOpen(false)}>
                    {t("button.close")}
                </Button>
            </DialogActions>
        </Dialog>

    </>
}